<template>
  <nav
    :class="
      currentActiveLink === '/' ||
      currentActiveLink === '/vod' ||
      currentActiveLink === '/berita'
        ? 'bg-transparent'
        : 'bg-normal'
    "
  >
    <div class="burger">
      <div class="d-flex">
        <div class="mr-2 burger-click cursor-pointer">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            @click="navSlide()"
          >
            <path
              d="M3 12.5H15M3 6.5H21M3 18.5H21"
              stroke="#D9E021"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <router-link class="logo-container d-md-none" :to="'/'">
          <img src="../assets/rtmklik/appLogo.png" alt="" />
        </router-link>
      </div>
    </div>

    <div
      class="left-section d-flex flex-row justify-content-start align-items-center"
    >
      <router-link class="logo-container d-none d-md-flex" :to="'/'" exact>
        <img src="../assets/rtmklik/appLogo.png" style="" alt="" />
      </router-link>
      <ul
        class="pl-3 nav-links"
        :style="
          window.width <= 768 && window.height
            ? `height: ${window.height}px`
            : 'height: 52px'
        "
      >
        <div class="close-icon" @click="navSlide()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#D9E021"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </div>
        <li class="nav-item d-flex justify-content-start d-md-none mb-3">
          <div class="logo-mobile-container">
            <img src="../assets/rtmklik/header-mobile-rtmlogo.svg" alt="" />
          </div>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :to="'/'"
            @click.native="closeOnRedirect()"
            >Utama
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :to="'/live/tv1'"
            @click.native="closeOnRedirect()"
            >TV
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :to="'/radiolist'"
            @click.native="closeOnRedirect()"
          >
            Radio
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :to="'/berita'"
            @click.native="closeOnRedirect()"
            >Berita
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :to="'/vod'"
            @click.native="closeOnRedirect()"
            style="width: 110px;"
          >
            Jom Tonton
          </router-link>
        </li>
        <li class="nav-item">
          <a class="nav-link" target="_blank" href="https://podcast.rtm.gov.my/"
            >Podcast</a
          >
        </li>
        <li class="nav-item dropdown">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            id="navbarDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Jadual
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <router-link
              class="dropdown-item text-left epg-nav-item"
              :to="'/epg-tv'"
              @click.native="closeOnRedirect()"
            >
              TV
            </router-link>
            <router-link
              class="dropdown-item text-left epg-nav-item"
              :to="'/epg-radio'"
              @click.native="closeOnRedirect()"
            >
              Radio
            </router-link>
          </div>
        </li>
        <div
          class="user-details-wrapper d-flex d-md-none align-items-center justify-content-between"
          v-if="authenticated"
        >
          <div class="d-flex">
            <div class="profile-icon-wrapper">
              <img
                :src="profileImage"
                alt="profile icon"
                class="w-100 h-100"
                @error="imageLoadError($event)"
              />
            </div>
            <div class="d-flex flex-column ml-3">
              <p class="mb-0 text-left profile-name">
                {{ profileDetails.name }}
              </p>
              <p class="mb-0 text-left profile-email">
                {{ profileDetails.email }}
              </p>
            </div>
          </div>

          <div class="cursor-pointer" @click="signOut()">
            <img src="../assets/rtmklik/logout-icon.svg" alt="" />
          </div>
        </div>
      </ul>
    </div>
    <div class="user-section d-flex flex-row mr-1 mr-md-3">
      <div class="user-section-icon mr-1 mr-md-3">
        <router-link
          :to="'/search'"
          :class="{ 'none-active': activeid == '/' }"
          style="text-decoration: none;"
          exact
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
          >
            <path
              d="M21.0031 21.5L16.6601 17.157M16.6601 17.157C17.403 16.4141 17.9923 15.5321 18.3944 14.5615C18.7964 13.5909 19.0033 12.5506 19.0033 11.5C19.0033 10.4494 18.7964 9.40905 18.3944 8.43842C17.9923 7.46779 17.403 6.58585 16.6601 5.84296C15.9172 5.10007 15.0353 4.51078 14.0647 4.10874C13.0941 3.70669 12.0537 3.49976 11.0031 3.49976C9.95253 3.49976 8.91222 3.70669 7.94159 4.10874C6.97096 4.51078 6.08902 5.10007 5.34614 5.84296C3.84581 7.34329 3.00293 9.37818 3.00293 11.5C3.00293 13.6217 3.84581 15.6566 5.34614 17.157C6.84647 18.6573 8.88135 19.5002 11.0031 19.5002C13.1249 19.5002 15.1598 18.6573 16.6601 17.157Z"
              stroke="white"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </router-link>
      </div>
      <!-- not logged in -->
      <div
        class="ml-3 ml-md-1 mr-2 mr-md-0 user-section-icon"
        v-if="!authenticated"
      >
        <router-link class="" :to="'/login'" exact>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
          >
            <path
              d="M20.8669 18.548C19.5816 16.2921 17.5745 14.5343 15.1688 13.5577C16.3651 12.6604 17.2488 11.4095 17.6947 9.98211C18.1406 8.55472 18.126 7.02322 17.6531 5.60454C17.1803 4.18587 16.273 2.95195 15.0598 2.07757C13.8467 1.20318 12.3892 0.732666 10.8938 0.732666C9.39837 0.732666 7.94086 1.20318 6.72772 2.07757C5.51458 2.95195 4.6073 4.18587 4.13441 5.60454C3.66152 7.02322 3.64699 8.55472 4.09287 9.98211C4.53875 11.4095 5.42245 12.6604 6.61878 13.5577C4.21308 14.5343 2.20601 16.2921 0.920654 18.548C0.841009 18.676 0.787926 18.8188 0.764561 18.9678C0.741195 19.1168 0.748025 19.269 0.784643 19.4153C0.821261 19.5616 0.886921 19.699 0.977718 19.8194C1.06851 19.9398 1.1826 20.0408 1.31318 20.1162C1.44376 20.1917 1.58818 20.2401 1.73785 20.2586C1.88752 20.2771 2.03939 20.2653 2.18442 20.224C2.32945 20.1826 2.46469 20.1126 2.5821 20.0179C2.6995 19.9232 2.79668 19.8059 2.86784 19.673C4.56659 16.7367 7.56659 14.9855 10.8938 14.9855C14.221 14.9855 17.221 16.7377 18.9197 19.673C19.0739 19.921 19.3186 20.0993 19.6019 20.1702C19.8852 20.2411 20.185 20.1991 20.4378 20.053C20.6907 19.9069 20.8769 19.6682 20.9569 19.3873C21.037 19.1064 21.0047 18.8055 20.8669 18.548ZM6.01878 7.86048C6.01878 6.89629 6.30469 5.95376 6.84036 5.15207C7.37604 4.35038 8.13741 3.72554 9.0282 3.35657C9.91899 2.98759 10.8992 2.89105 11.8448 3.07915C12.7905 3.26725 13.6591 3.73155 14.3409 4.41333C15.0227 5.09511 15.487 5.96376 15.6751 6.90941C15.8632 7.85507 15.7667 8.83527 15.3977 9.72606C15.0287 10.6168 14.4039 11.3782 13.6022 11.9139C12.8005 12.4496 11.858 12.7355 10.8938 12.7355C9.60131 12.734 8.36219 12.2199 7.44828 11.306C6.53436 10.3921 6.02027 9.15295 6.01878 7.86048Z"
              fill="white"
            />
          </svg>
        </router-link>
      </div>
      <div class="user-logged-in-wrapper d-flex align-items-center" v-else>
        <ul class="nav-links-profile mb-0">
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle d-flex align-items-center"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <div class="profile-icon">
                <img
                  :src="profileImage"
                  alt="profile icon"
                  class="w-100 h-100"
                  @error="imageLoadError($event)"
                />
              </div>
            </a>
            <div
              class="dropdown-menu user-logged-button"
              aria-labelledby="navbarDropdown"
            >
              <router-link
                class="dropdown-item text-left epg-nav-item"
                :to="'/profile'"
                exact
                >Profil</router-link
              >
              <div
                class="dropdown-item text-left epg-nav-item cursor-pointer"
                @click="signOut()"
              >
                Log Keluar
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
/* eslint-disable */
// is-active
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import { bus } from "../main";
import axios from "axios";
import defaultAvatar from "../assets/rtmklik/icon_user.svg";
// import newsTickerData from "../static/news-ticker.json";
export default {
  data: function() {
    return {
      activeid: "",
      showNavbar: true,
      lastScrollPosition: 0,
      newsData: [],
      tickerSpeed: 0,
      clickButton: false,
      profileImage: "",
      profileDetails: {
        name: "",
        email: "",
      },
      avatarCookies: this.$cookie.get("avatar"),
      currentActiveLink: "",
      window: {
        height: 0,
        width: 0,
      },
    };
  },
  created: function() {
    this.setActiveId();
  },
  methods: {
    ...mapActions({
      signOutAction: "auth/signOut",
    }),
    imageLoadError(event) {
      event.target.src = defaultAvatar;
    },
    navSlide() {
      const burger = document.querySelector(".burger-click");
      const nav = document.querySelector(".nav-links");
      const close = document.querySelector(".close-icon");

      burger.addEventListener("click", () => {
        nav.classList.add("nav-active");
        close.classList.add("close-icon-active");
      });

      close.addEventListener("click", () => {
        close.classList.remove("close-icon-active");
        nav.classList.remove("nav-active");
      });

      this.clickButton = !this.clickButton;
      document.body.style.overflow = this.clickButton ? "hidden" : "visible";
      document.body.style.height = this.clickButton ? "100%" : "auto";
    },
    closeOnRedirect() {
      const nav = document.querySelector(".nav-links");
      const close = document.querySelector(".close-icon");
      const currentBodyStyle = document.body.style.overflowY;

      close.classList.remove("close-icon-active");
      nav.classList.remove("nav-active");

      if (currentBodyStyle === "hidden") {
        document.body.style.overflow = "visible";
        document.body.style.height = "auto";
      }
      this.clickButton = false;
    },

    signOut() {
      this.signOutAction().then(() => {
        this.$router.replace({
          name: "home_new",
        });
      });
    },
    setActiveId() {
      this.activeid = this.$route.name;
    },
    onScroll() {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      if (currentScrollPosition < 0) {
        return;
      }
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 70) {
        return;
      }
      this.showNavbar = currentScrollPosition < this.lastScrollPosition;
      this.lastScrollPosition = currentScrollPosition;
    },

    async getJsonData() {
      var vm = this;
      let response = await axios.get(
        "https://rtm.glueapi.io/v3/content?idSchema=2015&&fieldPath=group&fieldValue=773&limit=100",
        {
          responseType: "json",
        }
      );

      vm.items = response.data.data;
      if (vm.items) {
        vm.newsData = vm.items;

        if (vm.items.length < 5) {
          vm.tickerSpeed = vm.items.length * 40;
        } else {
          vm.tickerSpeed = vm.items.length * 20;
        }
      } else {
        vm.tickerSpeed = 0;
      }
    },
    setOverlay() {
      this.clickButton = !this.clickButton;
      document.body.style.overflow = this.clickButton ? "hidden" : "visible";
      document.body.style.height = this.clickButton ? "100%" : "auto";
    },
    handleResize() {
      this.window.height = window.innerHeight + 2;
    },
  },
  mounted() {
    this.setActiveId();
    this.window.width = window.innerWidth;
    window.addEventListener("resize", () => {
      this.window.width = window.innerWidth;
    });
  },
  beforeDestroy() {
    // window.removeEventListener("scroll", this.onScroll);
  },
  beforeMount() {
    this.getJsonData();
    this.handleResize();
    this.$nextTick(function() {
      window.addEventListener("resize", () => {
        this.window.width = window.innerWidth;
      });

      window.addEventListener("load", () => {
        this.window.width = window.innerWidth;
      });
    });
  },
  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
    }),
    ...mapGetters("auth", {
      user: "user",
    }),
  },
  created: function() {
    this.$nextTick(function() {
      window.addEventListener("resize", () => {
        this.window.width = window.innerWidth;
      });
    });
  },
  watch: {
    user: {
      handler(user) {
        if (user) {
          const username = user.name ? user.name : "";
          const email = user.email ? user.email : "";
          this.profileDetails.name = username;
          this.profileDetails.email = email;
          const getUserImage = user.userImage[0];
          var avatarChanged = this.avatarCookies ? true : false;
          if (getUserImage) {
            if (avatarChanged) {
              this.profileImage = `https://rtm-images.glueapi.io/35x35/${
                this.avatarCookies
              }`;
            } else {
              this.profileImage = `https://rtm-images.glueapi.io/35x35/${
                getUserImage.subDirectory
              }/${getUserImage.fileName}`;
              this.$cookie.set(
                "avatar",
                `${getUserImage.subDirectory}/${getUserImage.fileName}`,
                {
                  expires: "12h",
                }
              );
            }
          } else {
            this.profileImage = defaultAvatar;
          }
        }
      },
      immediate: true,
    },
    "$route.path": {
      immediate: true,
      handler(n) {
        this.currentActiveLink = n;
      },
    },
  },
};
</script>

<style scoped>
.header-position {
  position: absolute;
  width: 100%;
  z-index: 1000 !important;
}
/* ticker */
@-webkit-keyframes ticker {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    visibility: visible;
  }
  100% {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}
@keyframes ticker {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    visibility: visible;
  }
  100% {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}
.ticker-wrapper {
  overflow: hidden;
  position: relative;
  z-index: 6;
  width: 100%;
  height: 2rem;
}
.ticker-wrap {
  position: absolute;
  top: 0;
  width: 100%;
  overflow: hidden;
  height: 2rem;
  z-index: 4;
  background-color: #313237;
  padding-left: 100%;
  box-sizing: content-box;
}
.ticker-wrap .ticker {
  display: inline-block;
  height: 2rem;
  line-height: 2rem;
  white-space: nowrap;
  padding-right: 100%;
  box-sizing: content-box;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  -webkit-animation-name: ticker;
  animation-name: ticker;
}
.ticker-wrap .ticker__item {
  display: inline-block;
  padding: 0 1rem;
  font-size: 14px;
  font-family: "HelveticaNeue-Medium";
  color: white;
}
@media only screen and (max-width: 1024px) {
}
@media only screen and (max-width: 991px) {
}
@media only screen and (max-width: 480px) {
  .ticker-wrap .ticker__item {
    padding: 2px 1rem;
    font-size: 12px;
  }
}

/*NAVIGATION*/
nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: Roboto;
  min-height: 72px;
  padding: 16px 20px;
  width: 100%;
}
.bg-normal {
  background: #171f26;
}
.bg-transparent {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1111;
  background: transparent;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.7) 0%,
    rgba(0, 0, 0, 0) 100%
  );
}
.active a {
  color: #d9e021 !important;
}
.left-section {
  width: 80%;
}
.logo-container {
  height: 50px;
}
.logo-container img {
  height: 100%;
}

.logo {
  color: var(--color1);
  text-transform: uppercase;
}

.nav-links {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 80%;
  margin-bottom: 0;
  padding: 0;
}
.nav-links-profile {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: auto;
  margin-bottom: 0;
  padding: 0;
}
.nav-links-profile li {
  list-style: none;
  max-width: 130px;
}
.nav-link {
  padding: 0 8px;
  text-align: left;
}

.nav-links li {
  list-style: none;
  max-width: 130px;
  padding: 12px 0;
}
.dropdown-item:hover,
.dropdown-item:focus {
  background: unset;
}

.dropdown-item {
  padding: 16px;
  color: #fff;
}
.nav-links a,
.nav-links div {
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.nav-links a:hover {
  border-bottom: 2px solid var(--color1);
  opacity: 1;
  color: #d9e021;
}
.router-link-exact-active {
  color: #d9e021 !important;
}

.user-section {
  float: right;
}

.user-avatar {
  width: 48px;
  height: 48px;
  display: inline-block;
  border-radius: 50%;
}

.user-dropdown-arrow {
  display: inline-block;
  margin-bottom: 32px;
}

.dropdown-arrow {
  color: var(--color1);
  align-content: right;
}

.burger {
  display: none;
}

.burger div {
  width: fit-content;
  margin: 4px;
  align-items: center;
}

.close-icon {
  position: absolute;
  top: 8px;
  right: 8px;
  opacity: 0;
  display: none;
  transform: rotate(90deg);
  transition: all 2s;
}

/*HERO BANNER*/
.hero-banner {
  height: 660px;
  width: 100%;
  background: linear-gradient(
      to right,
      rgba(20, 250, 80, 0.7),
      rgba(0, 130, 213, 0.8)
    ),
    url("https://www.overclockers.at/files/superm24_103685.jpg");
  background-size: cover;
  background-position: center;
  position: relative;
}

.hero-content {
  font-family: Roboto;
  position: absolute;
  top: 20%;
  left: 60px;
  width: 75%;
  max-width: 520px;
  min-width: 280px;
}
.hero-header {
  font-size: 64px;
  font-weight: 500;
  color: var(--color1);
  margin-bottom: 20px;
}

.hero-sub {
  font-size: 18px;
  font-weight: 300;
  color: var(--color1);
  line-height: 1.5;
  margin-bottom: 28px;
}

/*BUTTONS*/
.btn-round-solid {
  background-color: var(--color1);
  color: white;
  border: none;
  height: 48px;
  width: 220px;
  font-size: 18px;
  font-weight: 400;
  border-radius: 24px;
  margin: 20px 20px 0px 0px;
}

.btn-round-clear {
  background-color: transparent;
  color: var(--color1);
  border: 2px solid var(--color1);
  height: 48px;
  width: 220px;
  font-size: 18px;
  font-weight: 400;
  border-radius: 24px;
  margin: 20px 20px 0px 0px;
}

ion-icon {
  font-size: 24px;
  vertical-align: middle;
}
.dropdown-menu {
  background: #171f26;
  box-shadow: 0px 8px 8px -4px rgba(16, 24, 40, 0.03),
    0px 20px 24px -4px rgba(16, 24, 40, 0.08);
}
.navbar-dark .navbar-nav .router-link-exact-active {
  border-bottom: 2px solid #dae12f;
}
.user-logged-button {
  top: 12px !important;
  transform: translate3d(-84px, 26px, 0px) !important;
}
.profile-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.user-details-wrapper {
  width: 100%;
  height: auto;
  position: absolute;
  bottom: 0;
  padding: 24px 16px;
  border-top: 1px solid #d9e021;
}
.profile-icon-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.profile-name {
  color: #fff;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
.profile-email {
  color: #fff;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
/*MEDIA QUERIES*/
@media screen and (max-width: 768px) {
  body {
    overflow-x: hidden;
  }
  nav {
    padding: 16px 8px 16px 16px;
  }
  .logo-container {
    height: 52px;
  }
  .logo-mobile-container {
    height: 32px;
  }
  .logo-mobile-container img {
    height: 100%;
  }
  .nav-links {
    margin-top: 0;
    margin-left: 0;
    padding: 50px 20px 20px;
    position: absolute;
    top: 0px;
    left: 0px;
    background: #171f26;
    box-shadow: 0px 8px 8px -4px rgba(16, 24, 40, 0.03),
      0px 20px 24px -4px rgba(16, 24, 40, 0.08);
    max-width: 300px;
    display: flex;
    flex-direction: column;
    transform: translateX(-100%);
    transition: transform 0.5s ease-in;
    z-index: 500;
  }
  .nav-links a {
    margin-left: 0;
    color: white;
    border-bottom: none;
    font-size: 16px;
    width: 100%;
    text-align: left;
  }

  .nav-links li {
    width: 100%;
    max-width: 100%;
  }
  /* .nav-links a {
    padding: 12px 0;
  } */
  .nav-links a:hover {
    /*border-left: 4px solid rgba(255,255,255,1);*/
    border-bottom: none;
  }

  .nav-active {
    transform: translateX(0%);
  }

  .burger {
    display: block;
    position: absolute;
    left: 16px;
  }

  .close-icon-active {
    display: block;
    opacity: 1;
    transform: rotate(0deg);
  }

  .logo-container {
    position: relative;
  }

  .logo {
    color: var(--color1);
    text-transform: uppercase;
    position: static;
  }
  .dropdown-menu {
    margin-left: 12px;
    padding: 0px;
    border: none;
    margin-top: 12px;
  }
  .user-logged-button {
    transform: translate3d(-114px, 26px, 0px) !important;
  }
  .dropdown-item {
    padding: 8px;
  }
}
</style>
